export default __webpack_public_path__ + "static/team-ronald@2x-76783ed6f0af18914b7b42ae62117ac1.png";